import { SecurityActionType } from "./constants";

export const getDefaultState = () => ({
  isPwdResetDialogOpen: false,
  isPwdStrengthDialogOpen: false,
  security: {
    password: {
      policy_name: "",
    },
  },
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case SecurityActionType.SET_PWD_RESET_DIALOG_VISIBILITY:
      return setPwdResetVisible(state, action);
    case SecurityActionType.SET_PWD_STRENGTH_DIALOG_VISIBILITY:
      return setPwdStrengthVisible(state, action);
    case SecurityActionType.SET_SETTINGS:
      return setSettingsData(state, action);
    case SecurityActionType.CHANGE_POLICY:
      return setPolicy(state, action);
    default:
      return state;
  }
};

function setPolicy(state, { policy_name }) {
  return {
    ...state,
    security: {
      password: {
        ...state.password,
        policy_name,
      },
    },
  };
}

function setSettingsData(state, { data }) {
  return {
    ...state,
    security: data["security"],
  };
}

function setPwdResetVisible(state, { isOpen }) {
  return { ...state, isPwdResetDialogOpen: isOpen };
}

function setPwdStrengthVisible(state, { isOpen }) {
  return { ...state, isPwdStrengthDialogOpen: isOpen };
}
